import React, { useState } from 'react';
import ContactModal from './ContactModal';

const Services = () => {
  const [showForm, setShowForm] = useState(false);
  const services = [
    {
      image: "images/img-6.jpeg",
      title: "Residential Christmas Light Installation",
      description: "Transform your home into a winter wonderland with our professional residential holiday lighting in Barrie. We specialize in roofline displays, window outlines, and custom designs using commercial-grade LED lights. Our team handles everything from design consultation to installation and seasonal takedown, ensuring your home stands out beautifully throughout the holiday season."
    },
    {
      image: "images/img-2.jpeg", 
      title: "Commercial Holiday Lighting Services",
      description: "Attract customers and create festive ambiance with our professional Christmas lights Collingwood commercial services. We design and install stunning holiday displays for plazas, office buildings, restaurants, and retail spaces. Our commercial-grade outdoor lights Orillia are built to withstand harsh Canadian winters while maintaining brilliant illumination throughout the season."
    },
    {
      image: "images/img-5.jpeg",
      title: "Tree & Landscape Lighting",
      description: "Illuminate your outdoor spaces with our expert tree and landscape lighting services. We create magical displays that highlight your property's natural beauty using energy-efficient LED technology. From majestic evergreens to garden features, our holiday lighting installers Barrie bring your landscape to life with warm, inviting illumination."
    }
  ];

  return (
    <section className="max-md:pt-0 md:pt-0 md:mt-0 max-md:mt-[0rem]">
      <h1 className="dest_heading no-radius md:mb-6">Our Magic Services</h1>
      <section className="product max-sm:px-6 max-sm:mx-auto max-sm:container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
          {services.map((service, index) => (
            <div key={index} className="col-span-1">
              <div className="product-image">
                <img src={service.image} className="product-thumb" alt={service.title} />
                <button 
                  onClick={() => setShowForm(true)}
                  className="card-btn"
                >
                  Contact Now
                </button>
              </div>
              <div className="product-info">
                <h2 className="product-brand">{service.title}</h2>
                <p className="text-gray-600 mt-4 px-4 text-sm leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      
      <div className="flex justify-center my-8 max-sm:pb-6">
        <button 
          onClick={() => setShowForm(true)}
          className="btn-primary text-white border-0 py-3 px-8 focus:outline-none rounded-lg text-lg font-semibold"
        >
          Contact Now
        </button>
      </div>
      
      <ContactModal isOpen={showForm} onClose={() => setShowForm(false)} />
    </section>
  );
};

export default Services;